import Calendar, { type CalendarProps } from 'react-calendar'

import { getDateTimeLocale } from 'lib/dayjs'
import { useUserProfile } from 'store'

import styles from './_DateRangePicker.module.scss'

import 'react-calendar/dist/Calendar.css'
import '../InlineDatePicker/_inlineDatePicker.scss'

export default function DateRangePicker(props: CalendarProps): JSX.Element {
    const userData = useUserProfile()!

    const langCode =
        typeof userData?.language === 'object' && userData?.language?.code
            ? String(userData.language.code).toLowerCase()
            : 'en'

    return (
        <Calendar
            className={styles.dateRangePicker}
            selectRange
            locale={getDateTimeLocale(langCode)}
            tileContent={
                props.tileContent ??
                (() => <div className='dots-container'></div>)
            }
            {...props}
        />
    )
}